module.exports = __webpack_public_path__ + "static/media/live_help_24px.84709d19.svg";